<template>

    <div class="input-group my-2 ml-2">

      <div class="form-check mt-3 mb-3">
        <input class="form-check-input" type="checkbox" id="gridCheck1" v-model="reset">
        <label class="form-check-label h7 text-muted" for="gridCheck1">
          {{__('change-password')}}
        </label>
      </div>
      <transition name="fade">
      <div class="input-group my-2" v-if="reset">
        <div class="input-group-prepend">
          <span class="input-group-text rounded-0 bg-transparent input-group-prepend-account border-0 h6"> {{__('old-password')}} </span>
        </div>
        <input type="password" class="form-control rounded-0 bg-light myAccount-form-control-custom" style="border: 1px solid #dee2e6 !important" name="old_password"/>
      </div>
      </transition>
      <transition name="fade">
      <div class="input-group my-2" v-if="reset">
        <div class="input-group-prepend">
          <span class="input-group-text rounded-0 bg-transparent input-group-prepend-account border-0 h6">{{__('new-password')}}</span>
        </div>
        <input type="password" class="form-control rounded-0 bg-light myAccount-form-control-custom" style="border: 1px solid #dee2e6 !important" name="password" required/>
      </div>
      </transition>
      <transition name="fade">
      <div class="input-group my-2" v-if="reset">
        <div class="input-group-prepend">
          <span class="input-group-text rounded-0 bg-transparent input-group-prepend-account border-0 h6">{{__('confirm-password')}}</span>
        </div>
        <input type="password" class="form-control rounded-0 bg-light myAccount-form-control-custom" style="border: 1px solid #dee2e6 !important" name="password_confirmation" required/>
      </div>
      </transition>

    </div>

</template>

<script>
export default {
  name: "reset",
  data: function() {
    return {
      reset: false,
    }
  },
  methods: {
    __: function (key) {
      return window.AG.trans[key];
    },
    toogle: function() {
      this.reset = this.reset === false;
    }
  },

}
</script>
